import moment from 'moment';
import { apiInterceptor } from 'utils/apiInterceptor';
export const getMetabaseToken = async (
    projectId,
    siteId,
    startDate,
    endDate,
    timezone,
    dashboardId,
    exhibitorid
) => {
    try {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/analytics/getOverviewMetaBaseToken?` +
                `${projectId ? `projectId=${projectId}` : ''}` +
                `&startDate=${moment(startDate).format('YYYY-MM-DD HH:mm')}` +
                `&endDate=${moment(endDate).format('YYYY-MM-DD HH:mm')}` +
                `&timezone=${timezone}` +
                `&dashboard=${dashboardId}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );
        return await response.json();
    } catch (error) {
        console.error(error);
    }
};
